import { render, staticRenderFns } from "./ChatFileLoader.vue?vue&type=template&id=4f8ce9ec&scoped=true&"
import script from "./ChatFileLoader.vue?vue&type=script&lang=js&"
export * from "./ChatFileLoader.vue?vue&type=script&lang=js&"
import style0 from "./ChatFileLoader.vue?vue&type=style&index=0&id=4f8ce9ec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8ce9ec",
  null
  
)

export default component.exports